import { render, staticRenderFns } from "./DxPostWorkEmployeeTable.vue?vue&type=template&id=b3d99270&"
import script from "./DxPostWorkEmployeeTable.vue?vue&type=script&lang=js&"
export * from "./DxPostWorkEmployeeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports